import { render, staticRenderFns } from "./cModalEditUciBook.vue?vue&type=template&id=253230b1"
import script from "./cModalEditUciBook.vue?vue&type=script&lang=js"
export * from "./cModalEditUciBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports